import { MessagesIcon, UserIcon, PlusCircleIcon, LockIcon } from '../../../components/ui/icons';
import type { PopoverMenuItem } from '../../../components/ui/PopoverMenu';
import type { ConnectionTab } from '@wlb/shared/hooks/useUserConnections';
import type { UserConnectionItem } from '@wlb/shared/types/userProfile';
import { connectionDisplayName } from './connectionUser';

export type ConnectionMenuKey =
  | 'message'
  | 'respondRequest'
  | 'unfollow'
  | 'removeBuddy'
  | 'block';

/**
 * Mirrors the mobile connections sheet: the relation option depends on the tab
 * and on whether the row is already a follower back / an accepted buddy.
 */
export const buildConnectionsMenu = (
  tab: ConnectionTab,
  user: UserConnectionItem,
  t: (key: string, values?: Record<string, string | number>) => string,
): PopoverMenuItem<ConnectionMenuKey>[] => {
  const name = connectionDisplayName(user);

  const message: PopoverMenuItem<ConnectionMenuKey> = {
    key: 'message',
    icon: MessagesIcon,
    label: t('connections.actions.message', { name }),
  };
  const respondRequest: PopoverMenuItem<ConnectionMenuKey> = {
    key: 'respondRequest',
    icon: PlusCircleIcon,
    label: t('connections.actions.respondRequest', { name }),
  };
  const unfollow: PopoverMenuItem<ConnectionMenuKey> = {
    key: 'unfollow',
    icon: UserIcon,
    label: t('connections.actions.unfollow', { name }),
  };
  const removeBuddy: PopoverMenuItem<ConnectionMenuKey> = {
    key: 'removeBuddy',
    icon: UserIcon,
    label: t('connections.actions.removeBuddy'),
  };
  const block: PopoverMenuItem<ConnectionMenuKey> = {
    key: 'block',
    icon: LockIcon,
    label: t('connections.actions.block', { name }),
    destructive: true,
  };

  switch (tab) {
    case 'followers':
      return [message, user.following === 1 ? unfollow : respondRequest, block];
    case 'following':
      return [message, unfollow, block];
    default:
      return [message, user.isBuddy ? removeBuddy : respondRequest, block];
  }
};
